import { adminUsersApi } from 'entities/adminUser/api/adminUsersApi';
import { filter, find } from 'lodash-es';
import map from 'lodash-es/map';
import { makeAutoObservable, runInAction } from 'mobx';
import { AdminUserModel } from 'entities/adminUser/model/adminUserModel';
import { RootStore } from 'app/store/rootStore';

export class AdminUsersStore {
  private _rootStore: RootStore;

  public users: null | AdminUserModel[] = null;
  public isPending = false;
  public isError = false;

  constructor({ rootStore }: { rootStore: RootStore }) {
    this._rootStore = rootStore;
    makeAutoObservable(this);
  }

  public async fetch() {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      const data = await adminUsersApi.fetch();
      this.users = map(data, (item) => new AdminUserModel(item));
    } catch (e) {
      runInAction(() => {
        this.isPending = false;
        this.isError = true;
      });
      console.error(e);
    }
  }

  private _findById(id: string) {
    return find(this.users, (r) => r.id === id);
  }

  private _removeItem(id: string) {
    this.users = filter(this.users, (r) => r.id !== id);
  }

  public async delete(id: string) {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    const target = this._findById(id);

    if (target) {
      try {
        await target.delete();
        this._removeItem(id);
      } catch (e) {
        runInAction(() => {
          this.isPending = false;
          this.isError = true;
          this._rootStore.notificationsStore.errorMessage =
            'Не удалось удалить пользователя';
        });
        console.error(e);
      }
    }
  }
}
